import { IAct } from '@newo/api/gateway';
import { DateTime } from 'luxon';

export type TimelineItem =
    { type: 'separator'; date: string } | { type: 'event'; act: IAct };

const TIME_INTERVALS = {
    '1s': 1000,
    '10s': 10000,
    '5s': 5000,
    '1m': 60000,
    '2m': 120000,
    '10m': 600000,
    '30m': 1800000,
    '1h': 3600000
} as const;

type TimelineInterval = keyof typeof TIME_INTERVALS | number;

export const buildTimeline = (
    events: IAct[],
    isUTC: boolean,
    timeZone: string,
    interval: TimelineInterval = '1h'
): TimelineItem[] => {
    const result: TimelineItem[] = [];

    const intervalMs =
        typeof interval === 'number' ? interval : TIME_INTERVALS[interval];

    for (let index = 0; index < events.length; index += 1) {
        const current = events[index];

        if (index > 0) {
            const prev = events[index - 1];

            const prevTime = DateTime.fromISO(prev.datetime, { zone: 'utc' });
            const currentTime = DateTime.fromISO(current.datetime, {
                zone: 'utc'
            });

            const diffMs = currentTime.toMillis() - prevTime.toMillis();
            const datetime = current.datetime.endsWith('Z')
                ? current.datetime
                : `${current.datetime}Z`;

            const printDataTime = isUTC
                ? DateTime.fromISO(datetime)
                      .toUTC()
                      .toFormat('yyyy-MM-dd hh:mm a')
                : DateTime.fromISO(datetime)
                      .setZone(timeZone)
                      .toFormat('yyyy-MM-dd hh:mm a');

            if (diffMs >= intervalMs) {
                result.push({
                    type: 'separator',
                    date: printDataTime
                });
            }
        }

        result.push({
            type: 'event',
            act: current
        });
    }

    return result;
};
